
export default function ContactSection() {
  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Barlow, sans-serif' }}>
            Ready to Start Flying?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Contact us today to begin your aviation journey at Stiletto Airpark. We're here to help you achieve your flying dreams in Bertram, Texas.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h3>
              
              {/* Location */}
              <div className="mb-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg">
                    <i className="ri-map-pin-line text-teal-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Location</h4>
                    <p className="text-gray-600">
                      <strong>Stiletto Airpark (XS79)</strong><br />
                      8834 E FM 243<br />
                      Bertram, TX 78605
                    </p>
                  </div>
                </div>
              </div>

              {/* Airpark Info */}
              <div className="mb-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg">
                    <i className="ri-information-line text-teal-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Airpark Info/Visits</h4>
                    <a 
                      href="tel:512-635-0847" 
                      className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer"
                    >
                      Call/Text: 512-635-0847
                    </a>
                  </div>
                </div>
              </div>

              {/* Flight Training */}
              <div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg">
                    <i className="ri-plane-line text-teal-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Flight Training</h4>
                    <div className="space-y-2">
                      <div>
                        <p className="text-gray-700 font-medium">Bryson Agee</p>
                        <a 
                          href="tel:706-936-8961" 
                          className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer"
                        >
                          706-936-8961
                        </a>
                      </div>
                      <div>
                        <p className="text-gray-700 font-medium">Scott Wallace</p>
                        <a 
                          href="tel:512-658-3132" 
                          className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer"
                        >
                          512-658-3132
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Areas */}
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Service Areas</h3>
              <p className="text-gray-600 mb-4">
                We proudly serve the entire Central Texas aviation community in Bertram, including:
              </p>
              <div className="grid grid-cols-2 gap-2 text-sm text-gray-700">
                <div className="flex items-center">
                  <i className="ri-check-line text-teal-600 mr-2"></i>
                  Austin
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-teal-600 mr-2"></i>
                  Round Rock
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-teal-600 mr-2"></i>
                  Cedar Park
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-teal-600 mr-2"></i>
                  Leander
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-teal-600 mr-2"></i>
                  Temple
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-teal-600 mr-2"></i>
                  Killeen
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-teal-600 mr-2"></i>
                  San Marcos
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-teal-600 mr-2"></i>
                  DFW Area
                </div>
              </div>
            </div>
          </div>

          {/* Map and CTA */}
          <div className="space-y-8">
            {/* Google Map */}
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Find Us</h3>
              <div className="aspect-video rounded-lg overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3449.123456789!2d-97.9428!3d30.7431!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzDCsDQ0JzM1LjIiTiA5N8KwNTYnMzQuMSJX!5e0!3m2!1sen!2sus!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Stiletto Airpark Location"
                ></iframe>
              </div>
            </div>

            {/* Call to Action */}
            <div className="bg-teal-600 rounded-2xl p-8 text-white text-center">
              <h3 className="text-2xl font-bold mb-4">Ready to Take Flight?</h3>
              <p className="text-teal-100 mb-6">
                Join the many pilots who have started their aviation journey with us. Contact us today to schedule your first lesson!
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a 
                  href="tel:706-936-8961"
                  className="bg-white text-teal-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line mr-2"></i>
                  Call: 706-936-8961
                </a>
                <a 
                  href="tel:512-635-0847"
                  className="border-2 border-white text-white px-6 py-3 rounded-lg font-semibold hover:bg-white hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-message-3-line mr-2"></i>
                  Text: 512-635-0847
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
